require('/ui/components/marketingactivationpage/marketingactivationpage.module.scss.module.css');

export const root = "_root_1lowg_1";
export const imageContainer = "_image-container_1lowg_1";
export const image = "_image_1lowg_1";
export const header = "_header_1lowg_1";
export const description = "_description_1lowg_1";
export const progressBar = "_progress-bar_1lowg_1";
export const linkCardsContainer = "_link-cards-container_1lowg_1";
export const ctaContainer = "_cta-container_1lowg_1";
